import React from 'react'
import Subject from './Subject'
import csm from '../assets/CSE404mid21.pdf'
import cse from '../assets/CSE404end21.pdf'
export default function Oops() {
  return (
    <div>
       <Subject title="Object Oriented Programming(CSE404)" sub="OOPS" syllabus="#"mid="Q. Paper"
    book1="Object Oriented Programming With C++, 7th Edition, E Balagurusamy"
    book2="Mastering C++, 2nd Edition, Venugopal and Buyya, 2013, McGraw Hill Education"
    book2Link="https://tfetimes.com/wp-content/uploads/2015/09/Mastering-C-By-KR-Venugopal-1.pdf"
    book1Link="https://nibmehub.com/opac-service/pdf/read/Object%20Oriented%20Programming%20With%20C++%20by%20Balagurusamy.pdf" 
    int21="#" mid21={csm} end21={cse}
    int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
